module.exports = __webpack_public_path__ + "img/landing.648f54c9.png";